module.exports = __webpack_public_path__ + "img/sprinkle-11.55e6e932.jpg";